import { FrequencyRange } from "./frequencyRange";

export const frequencyRangesMinMax: {
  [frequencyRange in FrequencyRange]: {
    min: number;
    max: number;
  };
} = {
  [FrequencyRange.subBass]: { min: 45, max: 60 },
  [FrequencyRange.bass]: { min: 60, max: 250 },
  [FrequencyRange.lowMids]: { min: 250, max: 500 },
  [FrequencyRange.mids]: { min: 500, max: 2000 },
  [FrequencyRange.hiMids]: { min: 2000, max: 4000 },
  [FrequencyRange.presence]: { min: 4000, max: 6000 },
  [FrequencyRange.brilliance]: { min: 6000, max: 14000 },
};
